import { createAction, createSlice } from '@reduxjs/toolkit';

export interface User {
  picture: string;
  name: string;
  employeeType: 'ADMIN' | 'PROJECT_MANAGER' | 'TEAM_LEAD' | 'EMPLOYEE';
  empId: string;
  designation: string;
  email: string;
  phoneNumber: string;
  userName: string;
  firstName: string;
  lastName: string;
}

const initialState: User = {
  picture: 'https://cdn-icons-png.flaticon.com/512/147/147144.png',
  name: '',
  employeeType: 'EMPLOYEE',
  empId: '',
  designation: '',
  email: '',
  phoneNumber: '',
  userName: '',
  firstName: '',
  lastName: ''
};

export const revertAll = createAction('REVERT_ALL');

// Redux Toolkit slice
export const userReducer = createSlice({
  name: 'user',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUser: (state, action) => {
      state = action.payload;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(revertAll, () => initialState);
  },
});
export const { setUser } = userReducer.actions;
export default userReducer;
